import axios from 'axios'

export default {
  state: {
    sessionChecked: false,
    loggedIn: false,
    username: null,
    resellerDisplayName: null,
    roles: [],
  },
  getters: {
    sessionChecked: state => state.sessionChecked,
    isLoggedIn: state => state.loggedIn,
    isAdmin: state => state.roles.indexOf('Admin') >= 0,
    roles: state => state.roles,
    username: state => state.username,
    resellerDisplayName: state => state.resellerDisplayName,
  },
  mutations: {
    login(state, sessionDetails) {
      state.loggedIn = true
      state.username = sessionDetails.username
      state.resellerDisplayName = sessionDetails.resellerDisplayName
      state.roles = sessionDetails.roles
    },
    logout(state) {
      state.loggedIn = false
      state.username = null
      state.resellerDisplayName = null
      state.roles = []
    },
    setSessionChecked(state) {
      state.sessionChecked = true
    },
  },
  actions: {
    whoami({ commit, dispatch }) {
      return axios
        .get('/rest/user/whoami', {
          validateStatus: function(status) {
            return status >= 200 && status < 500
          },
        })
        .then(result => {
          if (result.status === 200) {
            commit('login', result.data)
          }
        })
        .finally(() => {
          commit('setSessionChecked')
        })
        .catch(() => {
          dispatch(
            'toast/addToast',
            {
              message: 'Error communicating with server',
              type: 'danger',
            },
            { root: true }
          )
        })
    },
    login({ commit, dispatch }, { username, password }) {
      return axios
        .post('/rest/user/login', { username, password })
        .then(result => {
          if (result.status >= 400) {
            throw new Error(
              `Received status [${result.status}] when logging in`
            )
          }
          if (result.data.success) {
            commit('login', result.data.sessionDetails)
            return { success: true }
          }
          return {
            success: false,
            message: 'Invalid username and/or password.',
          }
        })
        .catch(() => {
          dispatch(
            'toast/addToast',
            {
              message: 'Error communicating with server',
              type: 'danger',
            },
            { root: true }
          )
          return { success: false }
        })
    },
    logout({ commit }) {
      return axios.post('/rest/user/logout').then(() => commit('logout'))
    },
  },
}
